import ContinueBtn from '../Buttons/ContinueBtn/ContinueBtn';
import './DoneMain.css';
import { Link } from 'react-router-dom';
import Subscribe from '../../assets/image/Group 201.png'


const DoneMain = () => {
    return ( 
        <div className="donemain">
            <div className="donemaincontent">
                <img src={Subscribe} alt="subscribe" />
                <h2>Successfully Subscribed!</h2>
                <p>We will send you your credentials in an email soon.</p>
            </div>
            <div className="donemainbtns">
                <Link to="/subscriptions"><ContinueBtn /></Link>
            </div>
        </div>
     );
}
 
export default DoneMain;